module.exports = __webpack_public_path__ + "img/con-img1-1.60942d5a.png";